/** Full-page loading spinner shown while lazy-loaded chunks are fetching. */
export function PageLoader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-surface">
      <svg
        className="h-10 w-10 animate-spin text-primary"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      >
        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4" />
      </svg>
    </div>
  )
}
